// extracted by mini-css-extract-plugin
export default {"tile01":"Tile01_tile01__hDuHu","vectorParent":"Tile01_vectorParent__lkN5z","vectorIcon":"Tile01_vectorIcon__ZWFbW","badges":"Tile01_badges__dMlxR","div":"Tile01_div__5p8GQ"};